(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-size-chart"] && !Shopify.designMode) return;
  try {
    if (!window.mmSizeChartBound) {
 window.mmSizeChartBound = true;
 document.addEventListener('click', event => {
  const opener = event.target.closest('[data-mm-chart-open]');
  if (opener) {
   const dialog = document.getElementById(opener.getAttribute('aria-controls'));
   if (!dialog) return;
   event.preventDefault();
   dialog.mmOpener = opener;
   dialog.showModal();
  }
  const closer = event.target.closest('[data-mm-chart-close]');
  if (closer) closer.closest('dialog').close();
 });
 document.addEventListener('close', event => {
  if (event.target.matches('.mm-size-dialog')) event.target.mmOpener?.focus({preventScroll:true});
 }, true);
}
  } catch(e) { console.error(e); }
})();

})();
